import { stack } from "@styled-system/patterns";

export const wrapperClass = stack({
	gap: "16",
});
